import { z } from "zod";

// ==================
// Update Profile Request
// ==================

/** Request body for updating client profile */
export const UpdateClientProfileRequestSchema = z.object({
    first_name: z.string().max(255).optional(),
    last_name: z.string().max(255).optional(),
    company_name: z.string().max(255).optional(),
    company_website: z.string().max(500).optional().nullable(),
    profile_picture_id: z.string().optional().nullable(),
});

export type UpdateClientProfileRequest = z.infer<typeof UpdateClientProfileRequestSchema>;

// ==================
// Change Password Request
// ==================

/** Request body for changing password */
export const ChangePasswordRequestSchema = z.object({
    current_password: z.string().min(1),
    new_password: z.string().min(8),
});

export type ChangePasswordRequest = z.infer<typeof ChangePasswordRequestSchema>;

// ==================
// Request Email Change Request
// ==================

/** Request body for initiating email change */
export const RequestEmailChangeRequestSchema = z.object({
    new_email: z.email(),
    password: z.string().min(1),
});

export type RequestEmailChangeRequest = z.infer<typeof RequestEmailChangeRequestSchema>;

// ==================
// Verify Email Change Request
// ==================

/** Request body for verifying email change (public endpoint) */
export const VerifyEmailChangeRequestSchema = z.object({
    token: z.string(),
    email: z.email(),
});

export type VerifyEmailChangeRequest = z.infer<typeof VerifyEmailChangeRequestSchema>;

